/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { resetAllFilters, resetAuthor } from '../../features/filter/filterSlice';
import { fetchTags } from '../../features/tags/tagsSlice';
import Tag from './Tag';

export default function Tags() {
    const { tags } = useSelector((state) => state.tags);
    const { author } = useSelector((state) => state.filter);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchTags());
    }, [dispatch]);

    const resetAllFiltersHandler = () => dispatch(resetAllFilters());
    const resetAuthorFiltersHandler = () => dispatch(resetAuthor());

    return tags?.length > 0 ? (
        <section className="flex max-w-7xl gap-1 mx-auto border-b items-center">
            {author && (
                <div
                    onClick={resetAuthorFiltersHandler}
                    className="flex items-center bg-blue-600 text-white px-4 py-1 rounded-full cursor-pointer"
                >
                    <span>{author}</span>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.5"
                        stroke="currentColor"
                        className="w-4 h-4"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M6 18L18 6M6 6l12 12"
                        />
                    </svg>
                </div>
            )}

            <div className="flex-1  px-5 py-6 lg:px-0 flex gap-2 overflow-y-auto">
                {tags.map((tag) => (
                    <Tag key={tag.id} title={tag.title} />
                ))}
            </div>

            <div>
                <button
                    onClick={resetAllFiltersHandler}
                    className="bg-red-600 text-white px-4 py-1 rounded-full cursor-pointer"
                >
                    Reset Filter
                </button>
            </div>
        </section>
    ) : null;
}
